 <header class="register-user-form__header">
  <h2 class="register-user-form__title ci-heading-h2-s-bold">
    {{ 'Datos del viaje' | translate }}
  </h2>
  
  <span class="ci-paragraph-p1-regular register-user-form__subtitle">
    {{ 'Añade más información opcional sobre el viaje para personalizar aún más tu ruta' | translate }}
  </span>
</header>

<main class="register-user-form__main">
  <app-time-fields
    [form]="form()"
    formControlNameStartTime="startTime"
    formControlNameEndTime="endTime"
  />
  
  <app-movility-field
    [form]="form()" 
    formControlName="movilityType"
  />

  <app-location-field
    [form]="form()" 
    formControlName="startLocationAddress"
  />  
</main>